import * as yup from 'yup';

const phoneRegex = /^[0-9\-+ ]{8,14}$/;
export const registrationSchema = yup
  .object({
    name: yup.string().required('FACILITY.NAME_REQUIRED'),
    email: yup
      .string()
      .email('FACILITY.EMAIL_VALID')
      .required('FACILITY.EMAIL_REQUIRED'),
    phoneNo: yup
      .string()
      .matches(phoneRegex, 'FACILITY.PHONE_VALIDATION_ERROR')
      .required('FACILITY.PHONE_REQUIRED'),
    facilityNumber: yup.string().required('FACILITY.FACILITY_NUMBER_REQUIRED'),
    addressLine1: yup
      .string()
      .min(3, 'FACILITY.ADDRESS_LINE1_REQUIRED')
      .required('FACILITY.ADDRESS_LINE1_REQUIRED'),
    addressLine2: yup
      .string()
      .min(3, 'FACILITY.ADDRESS_LINE2_REQUIRED')
      .required('FACILITY.ADDRESS_LINE2_REQUIRED'),
    addressLine3: yup
      .string()
      .min(3, 'FACILITY.ADDRESS_LINE3_REQUIRED')
      .required('FACILITY.ADDRESS_LINE3_REQUIRED'),
    // zip: yup
    //   .string()
    //   .min(3, 'FACILITY.ADDRESS_LINE4_REQUIRED')
    //   .required('FACILITY.ADDRESS_LINE4_REQUIRED'),
  })
  .required();

export const addFacilitySchema = yup
  .object({
    name: yup.string().required('FACILITY.NAME_REQUIRED'),
    phoneNo: yup
      .string()
      .matches(phoneRegex, 'FACILITY.PHONE_VALIDATION_ERROR')
      .required('FACILITY.PHONE_REQUIRED'),
    facilityNumber: yup.string().required('FACILITY.FACILITY_NUMBER_REQUIRED'),
    addressLine1: yup
      .string()
      .min(3, 'FACILITY.ADDRESS_LINE1_REQUIRED')
      .required('FACILITY.ADDRESS_LINE1_REQUIRED'),
    addressLine2: yup
      .string()
      .min(3, 'FACILITY.ADDRESS_LINE2_REQUIRED')
      .required('FACILITY.ADDRESS_LINE2_REQUIRED'),
    addressLine3: yup
      .string()
      .min(3, 'FACILITY.ADDRESS_LINE3_REQUIRED')
      .required('FACILITY.ADDRESS_LINE3_REQUIRED'),
    // zip: yup
    //   .string()
    //   .min(3, 'FACILITY.ADDRESS_LINE4_REQUIRED')
    //   .required('FACILITY.ADDRESS_LINE4_REQUIRED'),
  })
  .required();
